var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"menu-list-item",domProps:{"textContent":_vm._s(_vm.indent(_vm.process))}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }